import { getTemplatePage } from "../../../data/models/page.model";
import { bus } from "@/main";
import { setInterval } from "timers";


export default {
	name: "HeaderBlock",
	data() {
		return {
			menuIsActive : false,
			content: [],
			isReady: false,
			colorElements: [],
			buttonHover: false,
			hiddenTitle: false,
			language: this.$route.params.lang,
			name: this.$route.name,
			newsletterOpen: false,
		}
	},
	props: {},
	created() {
		this.getContent();
		bus.$on("evalColors", () => {
			this.getSections();
			if (document.getElementById("primary")) {
				document.getElementById("primary").addEventListener("scroll", () => {
					this.getSections();
				});
			}
			if (document.getElementById("secondary")) {
				document.getElementById("secondary").addEventListener("scroll", () => {
					this.getSections();
				});
			}
			window.addEventListener("scroll", () => {
				// console.log("EVAL COLORS !! ")
				this.getSections();
			});
		});
		bus.$on("hideTitle", (value) => {
			this.hiddenTitle = value;
		});
	},
	watch: {
		"$route": function () {
			this.sections = [];
			this.language = this.$route.params.lang;
			this.name = this.$route.name;
			this.menuIsActive = false;
			this.getSections();
			this.getContent();	
			bus.$emit("toggleMenu", false);
		},
		"menuIsActive": function () {
			if (this.menuIsActive) {
				this.bodyScroll()
				this.buttonHover = false;
				
				setTimeout(() => {
					const menuElement = document.querySelector(".header-block__nav__menu")
					const logoElement = document.querySelector(".header-block__nav__logo")
					menuElement.querySelector(".header-block__nav__menu__text").style.color = "#000";
					logoElement.querySelector(".header-block__nav__menu__vector").style.color = "#000";
				}, 500);
			}
			else {
				this.bodyScroll(true)
			}
			setTimeout(() => {
				this.getSections();
			}, 300);
		}
	},
	computed: {},
	mounted() {
		window.addEventListener("scroll", () => {
			this.getSections();
		});
		window.addEventListener("resize", () => {
			this.getSections();
		});
	},
	methods: {
		getContent() {
			getTemplatePage("pages/contact-page.php").then( 
				content => {
					this.content = content;
					this.isReady = true
				}
			)
		},
		toggleMenu(close){
			this.menuIsActive = !this.menuIsActive;
			bus.$emit("toggleMenu", true);
		},
		bodyScroll(remove) {
			if (remove)
				document.querySelector("body").classList.remove("no--scroll")
			else
				document.querySelector("body").classList.add("no--scroll")
		},
		menuHover(state){
			if (this.menuIsActive)
				this.buttonHover = false
			else
				this.buttonHover = state;
		},
		getSections() {
			let elements = document.getElementsByClassName("element-colorize");
			let getColorElements = new Promise ((resolve,reject) => {
				for (let i = 0; i < elements.length; i++) {
					if (elements[i].attributes["data-logo-color"]) {
						this.colorElements.push(elements[i]);
					}
					if( i + 1  == elements.length)
						resolve(true)
				}
			});
			Promise.all([getColorElements]).then(() => {
				this.evalColorElement(".header-block__nav__logo", "svg");
				this.evalColorElement(".header-block__nav__menu", "span");
				// this.evalColorLogo(".header__title");
			})
		},
		evalColorElement(value, type) {
			let menuElement = document.querySelector(value);
			let found =  null;
			let i = 0
			
			while (!found && i < this.colorElements.length ) {
				
				let element = this.colorElements[i].getBoundingClientRect();
				
				if (menuElement 
					&& (menuElement.getBoundingClientRect().top + menuElement.getBoundingClientRect().height / 2 >= element.top ) 
					&& (menuElement.getBoundingClientRect().left + menuElement.getBoundingClientRect().width / 2 >= element.left ) 
					&& (menuElement.getBoundingClientRect().right - menuElement.getBoundingClientRect().width / 2 <= element.right ) 
					&& (menuElement.getBoundingClientRect().bottom - menuElement.getBoundingClientRect().height / 2 <= element.bottom ) 
				) 
				{
					if (type == "svg"){
						menuElement.querySelector(".header-block__nav__logo__vector").style.stroke = this.colorElements[i].attributes["data-logo-color"].value ;
					}
					if (type == "span") {
						menuElement.querySelector(".header-block__nav__menu__text").style.color = this.colorElements[i].attributes["data-logo-color"].value ;
					}
					else {
						menuElement.style.color = this.colorElements[i].attributes["data-logo-color"].value ;
					}
					found = true
				}
				i++;
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/header/header.block.js